import RegionCharts from "./ui/regionCharts";

export default RegionCharts;
